module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABI0lEQVRoQ+2awQ2CQBRE+dqGFkHiDRvwoLEKi7IKowcbkJsJRUgbul70Qtg4wwKbxfE88v+84f+NWS1L/GOJ95/JQOwEvQmsiv3maa9j5twiapNm9dzNDvfydG3rw2sgX+8e0Zv/dmxWV7fzkjNQbF1U8o3iVXlphe1PYGoGfASGSilvAAxOQAbIqJQASoAEC8vR+vAWmuwMNEnBiD9CH5jREpABzwmrBFAC7DuP6tH62kIoUVanBFACWqNao57p+ptXiN0uqB4FqHMAJcrqlABKAD0H2B9EaP3gGZCBwDWuBNjtgupHmwG0IVYnAygBliyqR+sHDzHaEKuTAfSAYsl21QffD3Qt3Nf3eAOpX/Ilf83aV/RDP0d/NRia8K/nJ5/AGz7+ZEAQfX82AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/course/c-ico04.png
// module id = 04o+
// module chunks = 1